import request from '@/utils/request'

export function index(params) {
  return request({
      url: 'hr/roles',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: 'hr/role/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `hr/roles/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: 'hr/roles',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `hr/roles/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `hr/roles/${id}`,
      method: 'delete',
  })
}
export function create() {
    return request({
        url: 'hr/role/create',
        method: 'get',
    })
  }
